import UserCredentials from "users/auth/credentials/user-credentials";

export default class LoginWithEmailAPIRequest {
  public email: string;
  public password: string;
  public rememberMe: boolean;

  public constructor(credentials: UserCredentials, rememberMe: boolean = false) {
    this.email = credentials.email.value;
    this.password = credentials.password.value;
    this.rememberMe = rememberMe;
  }
}
